var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72293 2.66667C4.80293 3.85333 5.00293 5.01333 5.32293 6.12L3.72293 7.72C3.17626 6.12 2.8296 4.42667 2.7096 2.66667H4.72293ZM17.8696 18.6933C19.0029 19.0133 20.1629 19.2133 21.3363 19.2933V21.28C19.5763 21.16 17.8829 20.8133 16.2696 20.28L17.8696 18.6933ZM6.00293 0H1.33626C0.60293 0 0.00292969 0.6 0.00292969 1.33333C0.00292969 13.8533 10.1496 24 22.6696 24C23.4029 24 24.0029 23.4 24.0029 22.6667V18.0133C24.0029 17.28 23.4029 16.68 22.6696 16.68C21.0163 16.68 19.4029 16.4133 17.9096 15.92C17.7763 15.8667 17.6296 15.8533 17.4963 15.8533C17.1496 15.8533 16.8163 15.9867 16.5496 16.24L13.6163 19.1733C9.84293 17.24 6.7496 14.16 4.8296 10.3867L7.76293 7.45333C8.13626 7.08 8.24293 6.56 8.09626 6.09333C7.60293 4.6 7.33626 3 7.33626 1.33333C7.33626 0.6 6.73626 0 6.00293 0Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.8e38335d01631dc6883a6e4441b38d16.svg";
export { ForwardRef as ReactComponent };